/* eslint-disable import/prefer-default-export */
// Helper function to extract links and filenames from a given message string
const extractLinksFromMessage = (message?: string): { url: string; name: string }[] => {
  if (!message) return [];

  // Regular expression to match URLs with specific file extensions
  const allowedExtensions = /\.(doc|docx|ppt|pptx|pdf|xls|xlsx|key|pages|png|jpeg|jpg|gif|tiff|csv)$/i;

  // Extract all URLs from the message
  const urlRegex = /https?:\/\/[^\s]+/g;
  const links = message.match(urlRegex) || [];

  // Filter the links by allowed file extensions and extract the filename
  return links
    .filter((link) => allowedExtensions.test(link))
    .map((link) => {
      // Extract the filename from the URL (everything after the last '/')
      const filename = link.substring(link.lastIndexOf("/") + 1);
      return { url: link, name: filename };
    });
};

export const extractAllFilesFromMessages = (
  messages?: {
    tracking_key: string;
    message?: string;
  }[],
) =>
  messages?.map((message) => {
    const links = extractLinksFromMessage(message.message);
    return {
      tracking_key: message.tracking_key,
      links,
    };
  });
